<template>
  <div class="home-header">
    <div class="logo">
      <img src="@/assets/image/home-logo.png" alt="logo" class="logo-img" />
    </div>
    <div class="menus">
      <MenuItem
        :labelimage="require('@/assets/image/sy.png')"
        menuname="首页"
        :active="currentActiveMenu === '首页'"
        @click="handleHomeClick"
      />
      <MenuItem
        :labelimage="require('@/assets/image/zxty.png')"
        menuname="在线体验"
        :active="currentActiveMenu === '在线体验'"
        :collapsable="true"
      >
        <div
          class="demo-option"
          @click.stop="handleDemoVersionClick('bar')"
        >
          <span class="demo-option-icon-wrap">
            <img
              class="demo-option-icon bar"
              src="https://ustatic.hudongmiao.com/miao/common/bar-icon_1783997705833557120.webp"
              alt=""
            />
          </span>
          <span class="demo-option-label">酒吧夜店版</span>
          <img
            class="hot-badge"
            src="https://ustatic.hudongmiao.com/miao/common/hot-icon_17839977058348e068a.webp"
            alt="HOT"
          />
        </div>
        <div
          class="demo-option"
          @click.stop="handleDemoVersionClick('lobster')"
        >
          <span class="demo-option-icon-wrap">
            <img
              class="demo-option-icon lobster"
              src="https://ustatic.hudongmiao.com/miao/common/lobster-icon_1783997705835d75478.webp"
              alt=""
            />
          </span>
          <span class="demo-option-label">龙虾烧烤</span>
        </div>
      </MenuItem>
      <MenuItem
        :labelimage="require('@/assets/image/csdl.png')"
        menuname="城市代理"
        :active="currentActiveMenu === '城市代理'"
        @click="handleCityAgentClick"
      />
      <MenuItem
        :labelimage="require('@/assets/image/sybz.png')"
        menuname="使用帮助"
        :active="currentActiveMenu === '使用帮助'"
        :collapsable="false"
        @click="handleHelpClick"
      />
    </div>
    <div class="tail-content">
      <div v-if="!hasToken" class="login-btn" @click="handleLoginClick">登录</div>
      <!-- <div v-if="!hasToken" class="register-btn">注册</div> -->
      <div v-if="hasToken" class="user-info">
        <div class="enter-bar-btn" @click="handleEnterBar">进入酒吧</div>
        <Dropdown
          :options="userMenuOptions"
          placement="end"
          @command="handleMenuCommand"
        >
          <template #trigger>
            <div class="user-profile">
              <img
                v-if="userInfo.headImg"
                :src="userInfo.headImg"
                alt="avatar"
                class="user-avatar"
              />
              <div v-else class="user-avatar-placeholder">
                {{ userInfo.userName ? userInfo.userName.charAt(0) : 'U' }}
              </div>
              <span class="user-name">{{ userInfo.userName || '用户' }}</span>
            </div>
          </template>
        </Dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from '@/components/Dropdown/Dropdown.vue';
import MenuItem from './MenuItem.vue';

export default {
  name: 'HomeHeader',
  components: {
    MenuItem,
    Dropdown,
  },
  props: {
    activeMenu: {
      type: String,
      default: '',
    },
  },
  computed: {
    // 根据当前路由的 meta 元数据计算激活的菜单项
    currentActiveMenu() {
      // 从当前路由和父路由中查找 activeMenu
      const { matched } = this.$route;
      for (let i = matched.length - 1; i >= 0; i -= 1) {
        if (matched[i].meta?.activeMenu) {
          return matched[i].meta.activeMenu;
        }
      }
      // 如果路由没有设置 activeMenu，则使用 prop（向后兼容）
      return this.activeMenu || '';
    },
    hasToken() {
      return !!(this.$store && this.$store.state.token);
    },
    userInfo() {
      return {
        userName: this.$store?.state.userName || '',
        headImg: this.$store?.state.headImg || '',
      };
    },
    userMenuOptions() {
      return [
        { label: '退出登录', value: 'logout' },
      ];
    },
  },
  methods: {
    handleLoginClick() {
      this.$emit('login');
    },
    handleHomeClick() {
      // 跳转到首页
      this.$router.push('/index');
    },
    handleDemoVersionClick(version) {
      // 打开新页面跳转到对应版本的在线体验地址
      const demoUrl = this.$store.state.demoActivityURL;
      const urlMap = {
        bar: demoUrl,
        lobster: 'https://screen.009bar.com/#/?liveId=363cbd33d7af410da1b1581aaa946bf7',
      };
      const url = urlMap[version] || demoUrl;
      if (url) {
        window.open(url, '_blank');
      }
    },
    handleCityAgentClick() {
      // 跳转到城市代理页面
      this.$router.push('/cityagent');
    },
    handleHelpClick() {
      // 跳转到使用帮助页面
      this.$router.push('/help');
    },
    handleEnterBar() {
      this.$emit('enter-bar');
    },
    handleMenuCommand(value) {
      if (value === 'logout') {
        // 退出登录
        this.$store.commit('resetUserInfo');
        // 刷新页面
        window.location.reload();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-header {
  /* 这里必须使用 fixed + !important，避免被父级作用域样式中统一设置的 position: relative 覆盖 */
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 62px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  color: #333;
  z-index: 1000;
  
  .logo {
    display: flex;
    flex-direction: row;
    margin-right: 50px;
    margin-left: 145px;
    
    .logo-img {
      width: auto;
      height: 48px;
    }
  }
  
  .menus {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 42px;
  }

  .demo-option {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 0;
    cursor: pointer;
    white-space: nowrap;

    .demo-option-icon-wrap {
      width: 16px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .demo-option-icon {
      object-fit: contain;

      &.bar {
        width: 11px;
        height: 10px;
      }

      &.lobster {
        width: 16px;
        height: 10px;
      }
    }

    .demo-option-label {
      margin-left: 8px;
      font-weight: 400;
      font-size: 12px;
      color: #000000;
      line-height: 20px;
    }

    .hot-badge {
      width: 18px;
      height: 8px;
      margin-left: 6px;
      flex-shrink: 0;
      object-fit: contain;
    }

    &:hover {
      .demo-option-label {
        font-weight: 500;
        color: #8D4FFE;
      }
    }
  }
  
  .tail-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    margin-left: auto;
    margin-right: 145px;
    gap: 22px;
    
    .login-btn {
      width: 87px;
      height: 33px;
      background: linear-gradient(90deg, #7149FF 0%, #CE5EFB 100%);
      box-shadow: inset 0px 4px 10px 0px rgba(56, 19, 156, 0.6);
      border-radius: 6px;
      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    /*
    .login-btn {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      background: linear-gradient(270deg, #7B4BFE 0%, #CD5EFB 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      cursor: pointer;
    }
    */

    /*
    .register-btn {
      width: 87px;
      height: 33px;
      background: linear-gradient(90deg, #7149FF 0%, #CE5EFB 100%);
      box-shadow: inset 0px 4px 10px 0px rgba(56, 19, 156, 0.6);
      border-radius: 6px;
      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    */

    .user-info {
      display: flex;
      align-items: center;
      gap: 22px;
    }

    .enter-bar-btn {
      width: 87px;
      height: 33px;
      background: linear-gradient(90deg, #7149FF 0%, #CE5EFB 100%);
      box-shadow: inset 0px 4px 10px 0px rgba(56, 19, 156, 0.6);
      border-radius: 6px;
      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .user-profile {
      display: flex;
      align-items: center;
      cursor: pointer;
      gap: 8px;
    }

    .user-avatar {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      object-fit: cover;
    }

    .user-avatar-placeholder {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: linear-gradient(90deg, #7149FF 0%, #CE5EFB 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFFFFF;
      font-size: 16px;
      font-weight: 500;
    }

    .user-name {
      font-size: 14px;
      color: #333;
      font-weight: 500;
    }
  }
}
</style>
